import { Report } from "./Report";

/**
 * Report for the number of downloaded fascicules
 * @extends {Report<number>}
 */
export class DownloadedFasciculesCountReport extends Report {
    /**
     * @param {import("./Report").GoogleAnalyticsReportSDK} googleAnalyticsSdk
     */
    static make(googleAnalyticsSdk) {
        return new DownloadedFasciculesCountReport(googleAnalyticsSdk);

    }

    /**
     * @type {Report<number>["run"]}
     */
    async run() {
        try {
            const data = await this.googleAnalyticsSdk.run(this.filterEmptyParams({
                dateRanges: this.getDateRanges(),
                dimensions: [{ name: "eventName" }],
                metrics: [{ name: "eventCount" }],
                dimensionFilter: {
                    filter: {
                        fieldName: "eventName",
                        stringFilter: {
                            matchType: "EXACT",
                            value: "FASCICULOS"
                        }
                    }
                }
            }));

            if (!data.rows) return 0;

            return Number(data.rows[0].metricValues[0].value);
        } catch (error) {
            console.error(error);
            throw new Error("Failed to fetch downloaded fascicules data");
        }
    }
}